import { render, staticRenderFns } from "./PopUpCreation.vue?vue&type=template&id=21f2b428&scoped=true"
import script from "./PopUpCreation.vue?vue&type=script&lang=js"
export * from "./PopUpCreation.vue?vue&type=script&lang=js"
import style0 from "./PopUpCreation.vue?vue&type=style&index=0&id=21f2b428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2b428",
  null
  
)

export default component.exports